<template>
  <div>
    <BSectionLoader
      :loading="
        $loading.isLoading([
          'getPackageDirectory',
          'packageSchemaBody',
          'packageSchemaPersonFull',
        ])
      ">
      <div class="mb-3">Спосіб генерації ID:</div>
      <package-id-mode-select
        v-model="idMode"
        class="mb-3"
        auto-description="Система присвоїть унікальний ID для нового клієнта"></package-id-mode-select>
      <b-input
        v-if="idMode === 'manual'"
        v-model="manualId"
        placeholder="Введіть ID клієнта"
        hide-details
        :error-messages="getErrorMessages(v$.manualId)"
        @blur="v$.manualId.$touch()"></b-input>
      <div class="my-3">Оберіть тип клієнта, щоб заповнити дані:</div>
      <package-directory-select
        v-model="personSchemaCredentials.personType"
        :height-full="false"
        :directory="directory.F082"></package-directory-select>
      <v-checkbox
        v-model="personSchemaCredentials.residence"
        label="Резидент"
        true-value="1"
        false-value="2"></v-checkbox>
    </BSectionLoader>
  </div>
</template>

<script lang="ts">
import { PropType, reactive, ref } from 'vue'
import { Dialog } from 'best-modules/plugins'
import {
  getPackageSchemaBody,
  getPackageSchemaPersonFull,
  createPackage,
} from '@/request/report'
import { PersonFullSchemaCredentials } from '@/utils/types'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { getErrorMessages } from 'best-modules/utils'
import { BSectionLoader } from 'best-modules/components'
import PackageDirectorySelect from './PackageDirectorySelect.vue'
import PackageIdModeSelect from './PackageIdModeSelect.vue'
import { usePackageDirectory } from '@/store/package-directory'
import { v4 as uuid } from 'uuid'
import { getPackageVersion } from '@/pages/report/package/versions'

export default {
  name: 'PackageManually',
  components: { PackageDirectorySelect, BSectionLoader, PackageIdModeSelect },
  props: {
    dialog: {
      type: Object as PropType<Dialog<'PackageManually'>>,
    },
  },
  methods: { getErrorMessages },
  setup(props) {
    const { directory, fillDirectory } = usePackageDirectory()
    fillDirectory()

    const personSchemaCredentials = reactive<PersonFullSchemaCredentials>({
      personType: '1',
      residence: '1',
    })

    const idMode = ref<'auto' | 'manual'>('auto')
    const manualId = ref('')

    const rules = {
      personType: { required },
      residence: { required },
      manualId: {
        required: (value: string) =>
          idMode.value === 'manual' ? !!value : true,
      },
    }

    const v$ = useVuelidate(rules, { ...personSchemaCredentials, manualId })

    const submit = async () => {
      await v$.value.$validate()
      if (!v$.value.$invalid) {
        const packageSchemaBody = await getPackageSchemaBody(
          props.dialog.dialogData.version
        )
        const packageSchemaPersonFull = await getPackageSchemaPersonFull(
          personSchemaCredentials,
          props.dialog.dialogData.version
        )

        const person_id_full =
          idMode.value === 'manual' ? manualId.value : uuid()

        packageSchemaPersonFull.person_full[0].person_id_full = person_id_full
        packageSchemaPersonFull.person_full[0].f082_person_type =
          personSchemaCredentials.personType
        packageSchemaPersonFull.person_full[0].k030_person_type_residence =
          personSchemaCredentials.residence

        const packageData = {
          data: [
            {
              data: getPackageVersion(
                props.dialog.dialogData.version
              ).buildManualPackageData({
                schemaBody: packageSchemaBody,
                schemaPersonFull: packageSchemaPersonFull,
              }),
              version: props.dialog.dialogData.version,
            },
          ],
          reportId: props.dialog.dialogData.reportId,
        }

        return createPackage({ ...packageData, createType: 'W' })
      }
    }

    return {
      personSchemaCredentials,
      idMode,
      manualId,
      v$,
      submit,
      directory,
    }
  },
}
</script>

<style scoped lang="scss"></style>
